import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import { WrapupModuleKillsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import getItemById from "@/src/util/getItemById";
import pluralize from "@/src/util/pluralize";
import styles from './wrapup.module.css';
import WrapupModuleAvatar, { WrapupUserAvatarSize } from "./avatar";

export default function WrapupModuleKillsComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.kills as WrapupModuleKillsData;
    const topKill = data.killedUserIds[0];
    const topKillUserId = topKill[0];
    const topKillCount = topKill[1];
    const topKillUser = getItemById(wrapupData.users, topKillUserId);

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h1>Kills</h1>
            <h3>You killed {pluralize(data.killCount, 'player')}, but one special player stood out...</h3>
            <WrapupModuleAvatar user={topKillUser} />
            <h3>You killed {topKillUser.name} {pluralize(topKillCount, 'time')}</h3>
            <h3>Your top kills:</h3>
            <table>
                <thead>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td></td>
                        <td>Name</td>
                        <td>Kills</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.killedUserIds.map(
                            (entry) => {
                                const userId = entry[0];
                                const kills = entry[1];
                                const user = getItemById(wrapupData.users, userId);

                                return <tr key={userId}>
                                    <td>
                                        <WrapupModuleAvatar user={user} size={WrapupUserAvatarSize.Small} />
                                    </td>
                                    <td>{user.name}</td>
                                    <td>{kills}</td>
                                </tr>
                            }
                        )
                    }
                </tbody>
            </table>
        </div>
    </DialogBody>
}
